import Header from "../Home/Screens/Header"
import ContentFooter from "../Services/Screens/ContentFooter"
import Privacy from "./privacy"

const PrivacyHome = () => {

    return (

        <>
            <Header />
            <Privacy />
            <ContentFooter />
        </>

    )
}


export default PrivacyHome